import { useTranslations } from 'next-intl';

import { UiKitTagBase } from '@/fo/ui/kit/tag/base';
import { UiKitTagGroup } from '@/fo/ui/kit/tag/group';

import { SortType } from '../../types';

import { styles } from './SortPanel.styles';

export interface SortPanelProps {
  sortType: SortType | null;
  onSortTypeChange: (sortType: SortType | null) => void;
}

export function SortPanel({ sortType, onSortTypeChange }: SortPanelProps) {
  const slots = styles();
  const t = useTranslations('review.sort');

  const handleSortTypeChange = (sortType: SortType | null) => {
    onSortTypeChange(sortType);
  };

  return (
    <div className={slots.base()}>
      <UiKitTagGroup
        selectionMode="single"
        value={sortType}
        onSelectionChange={handleSortTypeChange}
        className={slots.tagGroup()}
      >
        <UiKitTagBase value={SortType.Newest}>{t('newest')}</UiKitTagBase>
        <UiKitTagBase value={SortType.Oldest}>{t('oldest')}</UiKitTagBase>
      </UiKitTagGroup>
    </div>
  );
}
